// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"130":"1c1f6cb8","918":"e3c65189"}[chunkId] + ".css";
};